import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

import ApiService from '@dogfy/services/apiService'
import endpoints from '@dogfy/services/apiEndpoints'

import { useAccountStore } from './account'

export const useStocksStore = defineStore('stocks', () => {
  const accountStore = useAccountStore()

  const extrasAvailability = ref(null)
  const snackStocks = computed(() => extrasAvailability.value?.snacks)

  async function fetchStocks () {
    try {
      const userCountry = accountStore.user.country
      const { data } = await ApiService.get(endpoints.config.extrasAvailability(userCountry))

      extrasAvailability.value = data
    } catch (err) {
      console.error(err)
      // TODO: Add sentry error capture indicating that could not fetch extras availability.
    }
  }

  return {
    extrasAvailability,
    snackStocks,
    fetchStocks,
  }
})
